import { FormEvent, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ModalEstadoContext } from "../../contexts/ModalEstado";
import { listarIndicadores } from "../../services/indicadores";
import { IndicadoresLista } from "../../interfaces/indicadores";
import { useLocation } from "react-router-dom";
import { TarefasProjeto } from "../../interfaces/projetos";
import FiltrosDefault from "../FiltrosDefault";
import LoadingBarra from "../LoadingBarra";
import NenhumResultadoEncontrado from "../NenhumResultadoEncontrato";
import DivSituacao from "../DivSituacao";
import ModalIndicador from "../ModalIndicador";
import ModalTarefas from "../ModalTarefas";
import ModalIndicadorMensuracao from "../ModalMensuracao";
import "./index.css"

function Indicadores() {
  const { modal, modalExibir, atualizarInformacoes } = useContext(ModalEstadoContext)

  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)

  const idProjeto = paramsUrl.get("idProjeto");
  const grupo = paramsUrl.get("grupo");

  const usuarioExterno = localStorage.getItem("usuarioProjeto")

  const [processando, setProcessando] = useState(false);
  const [nenhumResultado, setNenhumResultado] = useState(false);
  const [situacao, setSituacao] = useState("");
  const [titulo, setTitulo] = useState("");
  const [indicadores, setIndicadores] = useState<IndicadoresLista[]>([]);
  const [indicadorSelecionado, setIndicadorSelecionado] = useState<IndicadoresLista>();
  const [tarefaSelecionada, setTarefaSelecionada] = useState<TarefasProjeto>();

  const filtrar = async (e: FormEvent) => {
    e.preventDefault()
    if (!idProjeto) return toast.error("Não foi possivel encontrar o Projeto.")
    if (!grupo) return toast.error("Não foi possivel encontrar o Grupo do Projeto.")
    setProcessando(true)
    setNenhumResultado(false)
    try {
      const queryParams = {
        titulo,
        situacao,
        grupo,
        idProjeto
      }

      const resposta = await listarIndicadores(queryParams)
      setIndicadores(resposta.data)
      if (resposta.status === 200 && resposta.data.length === 0) {
        setNenhumResultado(true)
        return setProcessando(false)
      }
      return setProcessando(false)
    } catch (error) {
      setProcessando(false)
      return toast.error("Erro ao Buscar os Indicadores")
    }
  }

  const abrirModalEditarIndicador = (indicador: IndicadoresLista) => {
    setIndicadorSelecionado(indicador);
    modalExibir("ModalIndicador")
  }

  const abrirModalCadastrarIndicador = () => {
    setIndicadorSelecionado(undefined);
    modalExibir("ModalIndicador")
  }

  const abrirModalTarefa = (tarefa: TarefasProjeto) => {
    
    setTarefaSelecionada(tarefa)
    modalExibir("ModalTarefa")

    return
  }

  const abrirModalNovaMensuracao = (indicador: IndicadoresLista) => {
    setIndicadorSelecionado(indicador)
    modalExibir("ModalNovaMensuracao")
  }

  useEffect(() => {
    const buscarIndicador = async () => {
      setProcessando(true)
      setNenhumResultado(false)
      if (!idProjeto) return toast.error("Não foi possivel encontrar o Projeto.")
      if (!grupo) return toast.error("Não foi possivel encontrar o Grupo do Projeto.")
      try {
        const queryParams = {
          titulo,
          situacao,
          grupo,
          idProjeto
        }

        const resposta = await listarIndicadores(queryParams)

        setIndicadores(resposta.data)
        if (resposta.status === 200 && resposta.data.length === 0) {
          setNenhumResultado(true)
          return setProcessando(false)
        }
        return setProcessando(false)
      } catch (error) {
        setProcessando(false)
        return toast.error("Erro ao Buscar os Indicadores")
      }
    }
    buscarIndicador()
  }, [atualizarInformacoes])

      useEffect (() => {

        if(modal.nome === '') setTarefaSelecionada(undefined)

    }, [modal])

  return (
    <div id='paginaContainer'>
      {processando && <LoadingBarra />}
      {nenhumResultado && <NenhumResultadoEncontrado />}
      <FiltrosDefault termo={titulo} situacao={situacao} placeholder='Pesquise pelo Titulo' tipo={!usuarioExterno ? "Vinculo" : ""} onChangeTermo={(e) => setTitulo(e.target.value)} onChangeSituacao={(e) => { setSituacao(e.target.value) }} acaoBtn={abrirModalCadastrarIndicador} listaSituacao={[{ nome: 'Todos', valor: '' }, { nome: 'Ativo', valor: 'Ativo' }, { nome: 'Inativo', valor: 'Inativo' }]} genero='masculino' isLoading={processando} maisFiltros={false} acaoMaisFiltro={() => { }} onSubmit={filtrar} />
      <section id='fundoContainerPagina'>
        <section className="lista-indicadores">
          {indicadores.map((indicador) => (
            <section className="container-indicador" key={indicador.id}>
              <span className="header-container-indicador" onClick={() => abrirModalEditarIndicador(indicador)}>
                <span className="nome-sigla-indicador">
                  <h1>{indicador.indicadore.titulo}</h1>
                  <p>{indicador.indicadore.sigla}</p>
                </span>
                <span className="situacao-indicador">
                  <DivSituacao texto={indicador.situacao} cor={indicador.situacao.toLowerCase()} />
                </span>
              </span>
              <span className="descricao-indicador" onClick={() => abrirModalEditarIndicador(indicador)}>
                <h3>Descrição</h3>
                <p>
                  {indicador.indicadore.descricao}
                </p>
              </span>
              <br />
              {!usuarioExterno && <span className="descricao-indicador" onClick={() => abrirModalEditarIndicador(indicador)}>
                <h3>Metodologia</h3>
                <p>
                  {indicador.indicadore.metodologia}
                </p>
              </span>}
              <section className="container-btn-indicador">
                {indicador.situacao === "Ativo" && !usuarioExterno && <button type="button" onClick={() => abrirModalTarefa(indicador.tarefa)}>Tarefa Vinculada</button>}
                {indicador.situacao === "Ativo" && !usuarioExterno && <button type="button" onClick={() => abrirModalNovaMensuracao(indicador)}>Nova Mensuração</button>}
              </section>
            </section>
          ))}
        </section>
      </section>
      {modal.nome === "ModalIndicador" && !usuarioExterno && <ModalIndicador indicador={indicadorSelecionado} />}
      {modal.nome === "ModalTarefa" && <ModalTarefas tarefa={tarefaSelecionada} />}
      {modal.nome === "ModalNovaMensuracao" && indicadorSelecionado?.idIndicador && <ModalIndicadorMensuracao indicador={indicadorSelecionado} />}
    </div>
  );
}

export default Indicadores;
